module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/my-home-lockup-2d0994477a412447f611b78c2b318489.svg";